
import { Component } from 'vue-property-decorator';
import CreateFlowForm from './create.vue';

@Component
export default class EditFlowForm extends CreateFlowForm  {
  get header() {
    return this.t('Duplicate Flow');
  }

  async load() {
    const originalFlowId = this.$store.getters.selectedItem.id;
    await this.flowApi.get(originalFlowId).then((data: any)=> {
      this.form = data;
      this.form.name = this.form.name + ' (' + this.t('____x.copy') + ')';
    });
  }
}
